export default __webpack_public_path__ + "static/media/23.ec92c464.jpg";